import Vue from 'vue'
import Vuex from 'vuex'
import menu from './modules/menu'
import login from './modules/login'
import video from './modules/video'
import enable from './modules/enable'
import getters from './getters'
import system from './modules/system'
import join from './modules/join.js'
import train from './modules/train'
import recommend from './modules/recommend'
import home from './modules/home'
import personal from './modules/personal'
import help from './modules/help'
import session from './modules/session'
import expert from './modules/expert'

// 保存数据
// this.$store.dispatch('asyncUpdateUser',data)
// 获取数据
// this.$store.getters.getUser

Vue.use(Vuex)
 

//初始化一个store实例，一定要new的，将所有的方法暴露出去，就可以在其它组件使用了

export default new Vuex.Store({
  getters,
  modules:{
    system,
    menu,
    login,
    video,
    enable,
    join,
    train,
    recommend,
    home,
    personal,
    help,
    session,
    expert
  },
})